import { useCallback, useEffect, useMemo, useState } from 'react'
import { classroomApi } from '../api/classroomApi'
import { useGetData } from './useGetData'

const useGetClassroom = ({ classRoomIds = [] }) => {
  const [classrooms, setClassrooms] = useState(null)
  const [loading, setLoading] = useState(true)
  const [classroomsMap, setClassroomsMap] = useState({})
  useEffect(() => {
    const fetchAllclassrooms = async () => {
      setLoading(true)
      try {
        const classroomPromises = classRoomIds.map(classroomId => classroomApi.getDetail(classroomId))
        const classroomResults = await Promise.all(classroomPromises)
        const classroomMap = {}
        const classrooms = []
        classroomResults.forEach((result, index) => {
          classroomMap[classRoomIds[index]] = result?.data
          classrooms[index] = result?.data
        })
        setClassroomsMap(classroomMap)
        setClassrooms(classrooms)
      } catch (error) {
        console.error('Failed to fetch classrooms:', error)
      } finally {
        setLoading(false)
      }
    }

    if (classRoomIds && classRoomIds.length > 0) {
      fetchAllclassrooms()
    }
  }, [JSON.stringify(classRoomIds)])
  return { classrooms, classroomsMap, loading }
}

export const useGetClassroomOptionsNotRole = (options) => {
  const { isActive = false, maxStudentInClass = null, isCode = false } = options || {}
  const { data } = useGetData(classroomApi.getListClassroomNotRole)
  const classRoomOptions = useMemo(() => {
    if (data && data?.length) {
      const filteredData = isActive ? data.filter(classroom => classroom.status === 'ACTIVE') : data
      return filteredData?.sort((a, b) => (b?.createdAt - a?.createdAt))?.map(classroom => {
        return {
          label: isCode ? classroom.code + ' - ' + classroom.name : classroom.name,
          value: classroom.id,
          centerId: classroom.centerId,
          capacity: classroom.capacity
        }
      })
    }
    return []
  }, [data])

  const getclassroomListDataByCenterId = useCallback((centerId = []) => {
    if (!classRoomOptions.length) return null
    return classRoomOptions.filter(item => !maxStudentInClass ? item.centerId === centerId : item.centerId === centerId && item.capacity >= maxStudentInClass)
  }, [classRoomOptions])
  return { data, classRoomOptions, getclassroomListDataByCenterId }
}
export default useGetClassroom
